import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';
import { getSqlDatabaseName, SqlImportDatabase } from 'cio/utils/sql-import';

export default class SqlImports extends Route {
  @service features!: FeaturesService;

  crumb() {
    let params = this.paramsFor(this.routeName) as { type: SqlImportDatabase };

    return {
      name: getSqlDatabaseName(params.type) ?? 'SQL Sync',
      path: 'sql-imports.index',
    };
  }
}
